import axios from "axios";
import { MAIN_URL } from "../Configurations/Urls";

function authHeaders() {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function fetchClientsForSelect() {
  const res = await axios.get(`${MAIN_URL}/api/client-management/clients/data`, {
    headers: authHeaders(),
  });
  return res?.data?.data || [];
}

export async function fetchClientApplicationContext(clientId) {
  const res = await axios.get(
    `${MAIN_URL}/api/client-management/clients/${clientId}/applications`,
    { headers: authHeaders() }
  );
  return res.data;
}

/** Form 1: client_applications only */
export async function assignApplicationToClient(clientId, payload) {
  const res = await axios.post(
    `${MAIN_URL}/api/client-management/clients/${clientId}/assign-client-application`,
    payload,
    { headers: authHeaders() }
  );
  return res.data;
}

/** Update subscription for an assigned client application. */
export async function updateClientApplicationSubscription(clientId, applicationId, payload) {
  const res = await axios.patch(
    `${MAIN_URL}/api/client-management/clients/${clientId}/applications/${applicationId}/subscription`,
    payload,
    { headers: authHeaders() }
  );
  return res.data;
}

/** Deactivate client application (blocks user access via organization_applications). */
export async function deactivateApplicationForClient(clientId, payload) {
  const res = await axios.patch(
    `${MAIN_URL}/api/client-management/clients/${clientId}/deactivate-client-application`,
    payload,
    { headers: authHeaders() }
  );
  return res.data;
}

/** Form 2: organization_applications + role seed */
export async function assignApplicationToOrganization(clientId, payload) {
  const res = await axios.post(
    `${MAIN_URL}/api/client-management/clients/${clientId}/assign-organization-application`,
    payload,
    { headers: authHeaders() }
  );
  return res.data;
}

/** EMS plan catalog (HR/PM return empty). */
export async function fetchApplicationPlans(params = {}) {
  const search = new URLSearchParams();
  if (params.application_id) search.set("application_id", params.application_id);
  if (params.application_key) search.set("application_key", params.application_key);
  if (params.billing_cycle) search.set("billing_cycle", params.billing_cycle);
  const qs = search.toString();
  const res = await axios.get(
    `${MAIN_URL}/api/application-plans${qs ? `?${qs}` : ""}`,
    { headers: authHeaders() }
  );
  return res.data;
}
